<template>
<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header p-2">
        <h6 class="modal-title">{{selectedLogInfo.category + " : " + selectedLogInfo.action}}</h6>
        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
          <span aria-hidden="true"><cancel-icon class="close-icon mt-1" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon></span>
        </button>
      </div>
      <div class="modal-body">
          <div class="assets-details-in-metadata-manager">
                <ul>
                    <li>
                        <div class="key-style">{{$t('Username')}}</div>
                        <div class="value-style">
                            <span v-if="Object.keys(selectedLogInfo).includes('username') && selectedLogInfo.username.length > 0">{{selectedLogInfo.username}}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </div>
                    </li>
                    <li>
                        <div class="key-style">{{$t('Ip')}}</div>
                        <div class="value-style">
                            <span v-if="Object.keys(selectedLogInfo).includes('client_system_ip') &&
                             selectedLogInfo.client_system_ip.length > 0">{{selectedLogInfo.client_system_ip}}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </div>
                    </li>
                    <li>
                        <div class="key-style">{{$t('DateTime')}}</div>
                        <div class="value-style">
                            <span v-if="Object.keys(selectedLogInfo).includes('action_datetime') && selectedLogInfo.action_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(selectedLogInfo.action_datetime)">{{checkIsTodayoryesterdayDate(selectedLogInfo.action_datetime)?getDateAndTimeInConfiguredFormat(selectedLogInfo.action_datetime, true) : getDateAndTimeInConfiguredFormat(selectedLogInfo.action_datetime)}}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </div>
                    </li>
                    <li>
                        <div class="key-style">{{$t('Category')}}</div>
                        <div class="value-style">
                            <span v-if="Object.keys(selectedLogInfo).includes('category') && selectedLogInfo.category.length > 0">{{selectedLogInfo.category}}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </div>
                    </li>
                    <li>
                        <div class="key-style">{{$t('Object')}}</div>
                        <div class="value-style">
                            <span v-if="Object.keys(selectedLogInfo).includes('object') && selectedLogInfo.object.length > 0">{{selectedLogInfo.object}}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </div>
                    </li>
                    <li>
                        <div class="key-style">{{$t('Action')}}</div>
                        <div class="value-style">
                            <span v-if="Object.keys(selectedLogInfo).includes('action') && selectedLogInfo.action.length > 0">{{selectedLogInfo.action}}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </div>
                    </li>
                    <li>
                        <div class="key-style">{{$t('Summary')}}</div>
                        <div class="value-style">
                            <span v-if="Object.keys(selectedLogInfo).includes('summary') && selectedLogInfo.summary.length > 0">{{selectedLogInfo.summary}}</span>
                            <span v-else class="validationmessage">No Data found</span>
                        </div>
                    </li>
                    <li>
                        <div class="key-style">{{$t('Detailed Information')}}</div>
                        <div class="value-style">
                            <pre style="color:#eee;word-break: break-word;white-space: pre-wrap;" v-if="Object.keys(selectedLogInfo).includes('detailed_information') && selectedLogInfo.detailed_information.length > 0">{{selectedLogInfo.detailed_information}}</pre>
                            <span v-else class="validationmessage">No Data found</span>
                        </div>
                    </li>
                </ul>
              </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import cancelIcon from "../core/InlineCancelField.vue"
import Utils from "../../components.utils";
// import {mapGetters} from "vuex"
// import moment from 'moment';

export default {
    props:["selectedLogInfo"],
    data(){
        return{
        activeIndex :null,
        activeIndexInfo:{},
        binIdList: [],
        }
    },
    components:{
        'cancel-icon':cancelIcon
    },
    created(){
    },
    methods: {
      humaniseSize(bytes){
        let data = Utils.humanizeSize(bytes)
        return `${data["value"]} ${data["unit"]}`
      },
      close(){
        this.$emit('close')
      },
      getColorToState(state){
        if (state == "COMPLETED") return {'color':'green'}; if (state == "FAILED" || state == "ABORTED") return {'color':'#cc6464'}; if (state == "QUEUED") return {'color':'orange'}; if (state == "IN_PROGRESS") return {'color':'orange'};
      },

      // getDateAndTimeInConfiguredFormat(dateTime){
      //   let dateAndTimeFormat = this.getStartUpDataFromInCache().dateTime_format ? this.getStartUpDataFromInCache().dateTime_format : "DD MMMM YYYY HH:mm:ss";
      //   let timeZone = this.getStartUpDataFromInCache().time_zone;
      //   let convertedToLocalTimeZone = Utils.convertToLocalTimeZone(dateTime, timeZone);
      //   return convertedToLocalTimeZone.format(dateAndTimeFormat);
      // },

      // getOnlyDateInConfiguredFormat(dateTime){
      //   let dateFormat = this.getStartUpDataFromInCache().date_format ? this.getStartUpDataFromInCache().date_format:"DD MMMM YYYY";
      //   let timeZone = this.getStartUpDataFromInCache().time_zone;
      //   let convertedToLocalTimeZone = Utils.convertToLocalTimeZone(dateTime, timeZone);
      //   return convertedToLocalTimeZone.format(dateFormat);
      // },

      // ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    },
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.validationmessage{
  color:$danger-color;
}

.modal-dialog {
    max-width: 800px;
    width: 800px;
    height: 550px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 300px;
      overflow: auto;
      user-select: text !important; 
      cursor:text;
    }
  }

/* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
    }
    
.modal {
  text-align: center;
  padding: 0!important;
  display:block;
  position: fixed;
  inset-inline-start: 0px;
  top: 8%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
      padding: 2%;
    }
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    margin-top:1%;
    justify-content: flex-start;
    button{
        height: 35px;
        width: 70px;
    font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:17%;
            text-align: start;
        }
        .value-style{
            color: $text-color;
            width: 70%;
            text-align: start;
            margin-inline-start: 11px;
        }
    }
}
</style>